module.exports = __webpack_public_path__ + "img/digital.82abf8df.jpg";